import { Box, ButtonGroup } from '@mui/material';

import { FORM_FIELD_TYPES, FormField } from '../../../../../components/form/form-field';
import SaveButton from '../../../../../components/form/save-button';
import { useNodeContext } from '../../../../../context/node-context';

const AppendTaskForm = ({
  form,
  onSubmit,
  onChange,
}: {
  form: any;
  onSubmit: any;
  onChange: any;
}) => {
  const { errors } = form.formState;
  const formControl = form.control;
  const { node } = useNodeContext() as { node: any };
  const { id: _id } = node;

  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      <FormField
        controlId="appendTaskFormName"
        label="name"
        name="name"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter name"
        required
        error={errors.name?.message}
      />
      <FormField
        controlId="appendTaskFormType"
        label="type"
        name="type"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={errors.type?.message}
      />
      <FormField
        controlId="appendTaskFormFunction"
        label="function"
        name="function"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={errors.function?.message}
        defaultValue="append"
      />
      <FormField
        controlId="appendTaskFormImporterRef"
        label="importerRef"
        name="parameters.importerRef"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Reference to the importer"
        required
        error={errors.parameters?.importerRef?.message}
      />
      <FormField
        controlId="appendTaskFormOutputConnector"
        label="outputConnector"
        name="parameters.outputConnector"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Output connector name"
        required
        error={errors.parameters?.outputConnector?.message}
      />
      <FormField
        controlId="appendTaskFormInputTable"
        label="inputTable"
        name="parameters.inputTable"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Input table name"
        required
        error={errors.parameters?.inputTable?.message}
      />
      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default AppendTaskForm;
